import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'
import ContactModal   from './ContactModal';
import BugReportModal from './BugReportModal';

const HelpMenu = ({ user }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showBug, setShowBug] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const onClickOutside = e => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    };
    if (openMenu) document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [openMenu]);

  if (!user) return null;

  return (
    <>
      <div className="help-menu" ref={menuRef}>
        <button
          className="help-btn"
          onClick={() => setOpenMenu(o => !o)}
          aria-label="Help menu"
        >
          ?
        </button>
        {openMenu && (
          <div className="help-menu-dropdown">
            <button onClick={() => { setShowContact(true); setOpenMenu(false); }}>
              Contact Support
            </button>
            <button onClick={() => { setShowBug(true); setOpenMenu(false); }}>
              Report a Bug
            </button>
            <Link
              to="/help-center"
              onClick={() => setOpenMenu(false)}
            >
              Help Center
            </Link>
          </div>
        )}
      </div>

      {showContact && <ContactModal close={() => setShowContact(false)} />}
      {showBug     && <BugReportModal close={() => setShowBug(false)} />}
    </>
  );
};

export default HelpMenu;
